import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSeo } from "@/lib/seo";

export default function NotFound() {
  useSeo({ title: "Page Not Found", description: "The page you are looking for could not be found.", path: "/404" });

  return (
    <section className="relative flex min-h-[70vh] items-center justify-center overflow-hidden px-5 text-center">
      <div className="absolute inset-0 ht-hero-glow" />
      <div className="absolute inset-0 ht-grid-lines opacity-50" />
      <div className="relative" data-testid="notfound-page">
        <p className="font-display text-7xl font-bold text-sky-400 sm:text-8xl">404</p>
        <h1 className="mt-4 font-display text-3xl font-semibold text-white">
          Page not found
        </h1>
        <p className="mx-auto mt-4 max-w-md text-base text-slate-400">
          The page you're looking for doesn't exist or may have been moved. Let's
          get you back on track.
        </p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Button
            asChild
            data-testid="notfound-home"
            className="rounded-full bg-sky-500 px-6 font-semibold text-[#040B16] hover:bg-sky-400"
          >
            <Link to="/">
              <Home size={18} className="mr-2" /> Back to Home
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="rounded-full border-slate-600 bg-transparent px-6 font-semibold text-white hover:bg-slate-800"
          >
            <Link to="/our-work">
              View Our Work <ArrowRight size={16} className="ml-2" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
